<div *ngIf="model.documents && (model.documents.length || queuedUploads)" [@fadeInOut]>
    <ul *ngIf="isDraggable" class="docs-list unstyled draggable" [dragula]="documentsSorted" [(dragulaModel)]="model.documents">
        <li *ngFor="let document of model.documents" class="">
            <div class="col-xs-1"><i class="glyphicon glyphicon-option-vertical"></i></div>
            <div class="col-sm-8">
                <a href="{{document.url}}" target="_blank">{{document.name}}</a><span *ngIf="!isDeletable(document)" class="afs">(AFS)</span>
            </div>
            <div class="col-sm-3 text-right">
              <button *ngIf="isDeletable(document) && !disabled; else acknowledgement" type="button" class="btn btn-danger" (click)="removeDocument(document)"><i class="glyphicon glyphicon-trash" title="Delete"></i></button>
              <ng-template #acknowledgement><i class="glyphicon glyphicon-lock"></i></ng-template>
            </div>
        </li>
    </ul>
    <ul *ngIf="!isDraggable" class="docs-list unstyled">
        <li *ngFor="let document of model.documents" class="">
            <div class="col-sm-9">
                <a href="{{document.url}}" target="_blank">{{document.name}}</a>
            </div>
            <div class="col-sm-3 text-right">
                <button *ngIf="!disabled; else acknowledgement" type="button" class="btn btn-danger" (click)="removeDocument(document)"><i class="glyphicon glyphicon-trash" title="Delete"></i></button>
                <ng-template #acknowledgement><i class="glyphicon glyphicon-lock"></i></ng-template>
            </div>
        </li>
    </ul>
    <ul class="docs-list unstyled">
      <li *ngFor="let upload of queuedUploads">
        <div class="col-sm-9">
          <p>{{upload.name}}</p>
        </div>
        <div class="col-sm-3 text-right">
          <div class="progress mb-0" >
            <div class="progress-bar" [ngStyle]="{'width.%': upload.progress}"></div>
          </div>
        </div>
      </li>
    </ul>
</div>
<div id="document-uploader">
    <div class="row">
        <div class="col-xs-12">
            <div ng2FileDrop
                    [ngClass]="{'nv-file-over': hasBaseDropZoneOver, 'disabled': !canUpload}"
                    (fileOver)="fileOverBase($event)"
                    (onFileDrop)="onAddingFiles($event)"
                    class="well my-drop-zone">
                <div>Drop files to upload</div>
                <div class="small">or</div>
                <button type="button" class="btn btn-outline" style="margin-top:6px;">
                    <label for="fileUploader">
                        Select Files
                        <input
                            id="fileUploader"
                            type="file"
                            ng2FileSelect
                            (onFileSelected)="onAddingFiles($event)"
                            [multiple]="(limit != 1)"
                            style="display: none;"
                        />
                    </label>
                </button>
            </div>
            <div *ngIf="fileSizeError" class="alert alert-danger text-center">File exceeds size limit ({{maxFileMBs}}MB).</div>
            <div *ngIf="fileUploadError" class="alert alert-danger text-center">There was an error uploading the file.</div>
        </div>
    </div>
</div>
<div class="shared-modal-component">
  <div class="backdrop" [ngStyle]="{'display': duplicateRecord ? 'block' : 'none'}" [@fadeIn]="duplicateRecord ? 'block' : 'none'"></div>
  <div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':duplicateRecord ? 'block' : 'none'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" (click)="duplicateRecord = false"><span aria-hidden="true">&times;</span></button>
          <div class="modal-title">Duplicate file(s) detected.</div>
        </div>
        <div class="modal-body">
          <div *ngFor="let file of queuedFiles">
            <div class="alert alert-success text-center">{{file.name}}</div>
          </div>
          <div *ngFor="let duplicate of duplicateFiles">
            <div class="alert alert-danger text-center">{{duplicate.name}}</div>
          </div>
          <div>
            <button class="btn btn-outline mr-1" (click)="duplicateRecord = false">Cancel</button>
            <button class="btn btn-primary mr-1" (click)="onFileSelected(queuedFiles.concat(duplicateFiles))">Upload All</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
